module.exports = __webpack_public_path__ + "img/multiplication-table-active.03719558.png";